module.exports = __webpack_public_path__ + "img/icon-bucket.b5d431a4.png";